import React from 'react';

import { Link } from 'react-router-dom';

import { bemCssModules } from '@utils';

import LoaderLayout from '@layouts/LoaderLayout';

import style from './ButtonLink.scss';

const cn = bemCssModules(style, 'ButtonLink');

export type TButtonLink = {
  className?: string;
  isLoading?: boolean;
  outline?: boolean;
  target?: string;
  to?: string;
  href?: string;
} & React.ButtonHTMLAttributes<HTMLAnchorElement>;

const ButtonLink: React.FC<TButtonLink> = props => {
  const {
    className,
    children,
    isLoading = false,
    disabled,
    href = '#',
    outline,
    to,
    ...rest
  } = props;

  const isDisabled = disabled || isLoading;
  const commonClassName = cn({ disabled: isDisabled, outline }, [className, 'button']);

  return to ? (
    <Link className={commonClassName} to={to} {...rest}>
      <LoaderLayout isLoading={isLoading} size={24}>
        {children}
      </LoaderLayout>
    </Link>
  ) : (
    <a className={commonClassName} rel="noreferrer" href={href} {...rest}>
      <LoaderLayout isLoading={isLoading} size={24}>
        {children}
      </LoaderLayout>
    </a>
  );
};

export default ButtonLink;
